<template>
  <div class="payment-slip-validation-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.create_times"
                class="filter-item-value date-picker-long"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="$commonFn.dateLimit(this, 31)"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
              <el-date-picker
                v-model="search.complete_times"
                class="filter-item-value date-picker-long"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="$commonFn.dateLimit(this, 31)"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.mini_qr_raw_content') }}</div>
              <el-input
                v-model="search.mini_qr_raw_content"
                size="small"
                type="text"
                maxlength="128"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.merchant_request_order_no') }}</div>
              <el-input
                v-model="search.mch_request_no"
                size="small"
                type="text"
                maxlength="64"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.verification_serial_no') }}</div>
              <el-input
                v-model="search.request_no"
                size="small"
                type="text"
                maxlength="64"
                class="filter-item-value"
                clearable
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.verification_result') }}</div>
              <el-select v-model="search.match_result" class="filter-item-value" size="small" clearable>
                <el-option :label="$t('dashboard.all')" :value="''" />
                <el-option
                  v-for="item in verificationResultOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.order_status') }}</div>
              <el-select v-model="search.order_status" class="filter-item-value" size="small" clearable>
                <el-option :label="$t('dashboard.all')" :value="''" />
                <el-option
                  v-for="item in orderStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
              <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <div class="total-container">
      <div class="total-item">
        {{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ summary.total_count }}</span>
      </div>
      <div class="total-item">
        {{ $t('data.total_payment_slip_validation_fee') }}: <span style="color:#3855F1;">THB {{ summary.total_fee | toDivideWithDot }}</span>
      </div>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('data.merchant_request_order_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.mch_request_no || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.verification_serial_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.request_no || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.mini_qr_raw_content')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-tooltip placement="top" :content="scope.row.mini_qr_raw_content">
              <span class="show-ellipsis">{{ scope.row.mini_qr_raw_content || '-' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.transaction_amount_thb')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.bank_trans_amount">{{ scope.row.bank_trans_amount | toDivideWithDot }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.order_status')" align="center" width="120">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getOrderStatusType(scope.row.order_status)">{{ getOrderStatusLabel(scope.row.order_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.verification_result')" align="center" min-width="110">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getVerificationResultType(scope.row.match_result)">{{ getVerificationResultLabel(scope.row.match_result) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column width="160" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time || '-' }}
          </template>
        </el-table-column>

        <el-table-column width="160" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

    <PaymentSlipValidationDetailModal
      ref="paymentSlipValidationDetailModal"
      :visible.sync="detailModalVisible"
    />
  </div>
</template>

<script>
import { fetchPaymentSlipValidationList, fetchPaymentSlipValidationListDownload } from '@/api/data/data'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import { paymentSlipValidationOrderStatusMap, paymentSlipVerificationResultMap } from '@/utils/maps'
import PaymentSlipValidationDetailModal from './Modal/PaymentSlipValidationDetailModal.vue'

export default {
  name: 'Payment_Slip_Validation_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PaymentSlipValidationDetailModal
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        create_times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        complete_times: null,
        mini_qr_raw_content: '',
        mch_request_no: '',
        request_no: '',
        match_result: null,
        order_status: null
      },
      tableData: [],
      summary: {
        total_count: 0,
        total_fee: 0
      },
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false,
      detailModalVisible: false
    }
  },
  computed: {
    verificationResultOptions() {
      return paymentSlipVerificationResultMap()
    },
    orderStatusOptions() {
      return paymentSlipValidationOrderStatusMap()
    },
    getOrderStatusType() {
      return function(value) {
        const result = paymentSlipValidationOrderStatusMap(value)
        return (result && result.type) || 'info'
      }
    },
    getOrderStatusLabel() {
      return function(value) {
        const result = paymentSlipValidationOrderStatusMap(value)
        return (result && result.label) || '-'
      }
    },
    getVerificationResultType() {
      return function(value) {
        const result = paymentSlipVerificationResultMap(value)
        return (result && result.type) || 'info'
      }
    },
    getVerificationResultLabel() {
      return function(value) {
        const result = paymentSlipVerificationResultMap(value)
        return (result && result.label) || '-'
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getPaymentSlipValidationList(params) {
      this.listLoading = true
      fetchPaymentSlipValidationList(params).then((res) => {
        const { total = 0, list = [] } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.summary = (res.data && res.data.summary) || { total_count: 0, total_fee: 0 }
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { create_times = [], complete_times = [], mini_qr_raw_content, mch_request_no, request_no, match_result, order_status } = this.search
      let params = {
        mini_qr_raw_content,
        mch_request_no,
        request_no,
        match_result,
        order_status,
        create_time_start: create_times && create_times[0],
        create_time_end: create_times && create_times[1],
        complete_time_start: complete_times && complete_times[0],
        complete_time_end: complete_times && complete_times[1],
        is_search_count: true,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },
    getDownloadParams() {
      const { create_times = [], complete_times = [], mini_qr_raw_content, mch_request_no, request_no, match_result, order_status } = this.search
      return filterEmptyAttr({
        create_time_start: create_times && create_times[0],
        create_time_end: create_times && create_times[1],
        complete_time_start: complete_times && complete_times[0],
        complete_time_end: complete_times && complete_times[1],
        mini_qr_raw_content,
        mch_request_no,
        request_no,
        match_result,
        order_status
      })
    },
    validateFilterTime() {
      const { create_times, complete_times } = this.search
      const hasCreateTime = Array.isArray(create_times) && create_times.length > 0 && create_times[0] && create_times[1]
      const hasCompleteTime = Array.isArray(complete_times) && complete_times.length > 0 && complete_times[0] && complete_times[1]
      if (!hasCreateTime && !hasCompleteTime) {
        this.$message.warning(this.$t('data.create_complete_time_cannot_both_empty'))
        return false
      }
      return true
    },
    handleFilter(otherParams = {}) {
      if (!this.validateFilterTime()) {
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentSlipValidationList(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {
        create_times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        complete_times: null,
        mini_qr_raw_content: '',
        mch_request_no: '',
        request_no: '',
        match_result: null,
        order_status: null
      }
    },
    onClickDowmloadBtn() {
      if (!this.validateFilterTime()) {
        return
      }
      const params = this.getDownloadParams()
      if (!params) {
        return
      }
      this.downloading = true
      fetchPaymentSlipValidationListDownload(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Payment_Slip_Validation_List')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },
    handleXlsxData(data = []) {
      const rows = [[
        this.$t('data.merchant_request_order_no'),
        this.$t('data.verification_serial_no'),
        this.$t('data.mini_qr_raw_content'),
        this.$t('data.transaction_amount_thb'),
        this.$t('data.order_status'),
        this.$t('data.verification_result'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.mch_request_no,
            tr.request_no,
            tr.mini_qr_raw_content,
            tr.bank_trans_amount,
            this.getOrderStatusLabel(tr.order_status),
            this.getVerificationResultLabel(tr.match_result),
            tr.transaction_create_time,
            tr.transaction_return_time || '-'
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickDetailTxt(row) {
      this.$refs.paymentSlipValidationDetailModal.changModalStatus(true, row.request_no)
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-slip-validation-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
  }
  .show-ellipsis{
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  .date-picker-long{
    width: calc(110% ) !important;
  }
}
</style>
